import validate from "/app/common/temp/node_modules/.pnpm/nuxt@3.15.0_@parcel+watcher@2.5.0_@types+node@22.9.0_db0@0.2.1_eslint@9.14.0_jiti@2.4.2__iore_7k2zwalix74upbfrkp74sdzniu/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/app/webapp/middleware/redirect.global.ts";
import manifest_45route_45rule from "/app/common/temp/node_modules/.pnpm/nuxt@3.15.0_@parcel+watcher@2.5.0_@types+node@22.9.0_db0@0.2.1_eslint@9.14.0_jiti@2.4.2__iore_7k2zwalix74upbfrkp74sdzniu/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}